import 'scripts/tarteaucitron.js.erb'
window.timeExpire = 365
